// This can downgrade the A type if its readonly or nonempty
// ex: f (a: ReadonlyArray<number>) => any & a: ReadonlyNonEmptyArray<number> returns ReadonlyArray<number>

// @see https://github.com/microsoft/TypeScript/issues/9998
export const tap = <A>(f: (a: A) => unknown) => (a: A): A => {
  f(a);
  return a;
};
